import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import PDLBorder from "../../components/PDLBorder";
import Logo from "../../components/Logo";
import '../../assets/css/character-creation.css';
import AuthHeader from "../../components/AuthHeader";
import characterCreation from '../../assets/img/character-creation.png';
import {createMyCharacterRequest, setMyCharacter} from "../../redux/UserCharacter/action";
import {useNavigate} from "react-router-dom";
import {setAlert} from "../../redux/Alert/action";

const Create = (props) => {

    const navigator = useNavigate();
    const [loading, setLoading] = useState(null);
    const [image, setImage] = useState(null);
    const [form, setForm] = useState({
        name: '',
        character_id: '',
        logo: null,
    });

    const onChangeHandler = (event) => {
        let {name, value} = event.target;

        setForm((preVal) => {
            return {
                ...preVal,
                [name]: value,
            }
        });
    }

    const onChangeFile = (event) => {
        let files = event.target.files[0];
        let nameArr = files.name.split('.');
        let fileType = nameArr[nameArr.length-1];
        if(
            fileType === 'jpg' || fileType === 'JPG' || 
            fileType === 'png' || fileType === 'PNG' || 
            fileType === 'jpeg' || fileType === 'JPEG'
        ){
            setForm((preVal) => {
                return {
                    ...preVal,logo: files,
                }
            });
            let output = document.getElementById('output');
            output.src = URL.createObjectURL(files);
            setImage(output.src);
            output.onload = function () {
                URL.revokeObjectURL(output.src) // free memory
            }
        }
        else{
            props.setAlert([{message: `Only jpg,png,jpeg is allowed!`,color :'warning'}]);
            return true;
        }
    }


    const onSubmitHandler = async (event) => {
        event.preventDefault();
        let formData = new FormData();
        formData.append('name', form.name);
        formData.append('logo', form.logo);
        formData.append('character_id', form.character_id);
        setLoading(true);
        props.createMyCharacter(formData)
            .then(() => {
                setLoading(false);
                console.log("true");
                navigator('/profile', { replace: true });
            })
            .catch((e) => {
                setLoading(false);
                console.log(e);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    useEffect(()=>{
        return ()=>{

        }
    },[]);

    return (
        <section className="fram-sec">
            <div className="frame-wrapper">

                {/* Border*/}
                <PDLBorder/>
                {/*Logo*/}
                <Logo/>

                {/*Menus*/}
                <div className="row">
                    {/*<div className="col-md-7">*/}

                    {/*</div>*/}
                    <div className="col-md-12">
                        <div className="Menus text-right">
                            <AuthHeader/>
                        </div>
                    </div>
                </div>
                {/*Menus*/}

                <section className="character">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3"></div>
                            <div className="col-lg-6">
                                <div className="character-creation text-center">
                                    <figure>
                                        <img src={characterCreation} className="img-fluid" alt=""/>
                                    </figure>
                                </div>
                                <div className="character-form-wrapper">
                                    <form onSubmit={onSubmitHandler}>
                                        <div className="from-group row">
                                            <div className="col-md-6">
                                                <select onChange={onChangeHandler} name="character_id"
                                                        className={"form-control inputCustomHeight character-name"}>
                                                    <option value="" hidden>Select Character</option>
                                                    {
                                                        props.character.map((val, key) => {
                                                            return <option key={key} value={val.id}>{val.title}</option>
                                                        })
                                                    }
                                                </select>
                                                {/*<input type="text" required={true} value={form.character_id} name={"character_id"}*/}
                                                {/*       className="form-control character-name"*/}
                                                {/*       placeholder="The warrior"/>*/}
                                            </div>
                                            <div className="col-md-6">
                                                <input type="text" onChange={onChangeHandler} required={true}
                                                       name={"name"} defaultValue={form.name}
                                                       className="inputCustomHeight form-control"
                                                       placeholder="Type Character Name"/>
                                            </div>
                                        </div>

                                        {/*<div className="form-group row mt-4">*/}
                                        {/*    <div className="col-md-4">*/}
                                        {/*        <div className="input-images">*/}
                                        {/*            <div className="image-uploader" id={"output"} style={*/}
                                        {/*                image && {*/}
                                        {/*                    backgroundImage: `url('${image}')`,*/}
                                        {/*                }*/}
                                        {/*            }>*/}
                                        {/*                <label htmlFor="customFile">*/}
                                        {/*                    <div className="upload-text">*/}
                                        {/*                        /!*<i className="material-icons">cloud_upload</i>*!/*/}
                                        {/*                        <span>Upload logo</span>*/}
                                        {/*                    </div>*/}
                                        {/*                </label>*/}
                                        {/*                <input type="file"*/}
                                        {/*                       required={true}*/}
                                        {/*                       onChange={onChangeFile}*/}
                                        {/*                       id="customFile"*/}
                                        {/*                       name="logo"/>*/}
                                        {/*                <div className="uploaded"></div>*/}

                                        {/*            </div>*/}
                                        {/*        </div>*/}
                                        {/*    </div>*/}
                                        {/*</div>*/}

                                        <div className="form-group mt-4">
                                            {
                                                loading ?
                                                    <button type={"button"} className="btn">
                                                        <i className={"fa fa-spinner fa-spin"}></i>
                                                    </button>
                                                    :
                                                    <button type={"submit"} className="btn">submit</button>
                                            }
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="col-lg-3"></div>
                        </div>
                    </div>
                </section>

            </div>
        </section>
    );
}

const mapStateToProps = (state) => {
    return {
        islogin: state.Auth.islogin,
        character: state.Site.characters,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        createMyCharacter: (data) => dispatch(createMyCharacterRequest(data)),
        setAlert: (data) => dispatch(setAlert(data)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Create);